import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'

export const Wrapper = styled('div')<{ theme?: TTheme }>`
    display: flex;
    flex-direction: column;
    height: 100%;
    color: ${({ theme }) => theme.colors.greys[800]};

    .note {
        margin: 24px 0;
        font-weight: 400;
        font-size: var(--font-size-s);
        line-height: 17px;
    }

    .multi-tag-input {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        min-height: 136px;
        border-radius: 4px;
        background-color: transparent;
        border: 1px solid
            ${({ theme }) => theme.colors.semantic.drawerSeparator};
    }

    .tag {
        padding: 0 10px;
        height: 40px;
        border-radius: 3px;
        font-weight: normal;
        font-size: var(--font-size-s);
        line-height: 17px;
        display: flex;
        align-items: center;
        color: var(--color-greys-500);
        white-space: nowrap;
        overflow: hidden;

        span {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            min-width: 0;
        }

        &.is-valid {
            background-color: ${({ theme }) =>
                `${theme.colors.semantic.validDomain}`};
            cursor: default;
            .close-btn {
                cursor: pointer;
                margin-left: 18px;
                svg {
                    fill: ${({ theme }) => `${theme.colors.primary[500]}`};
                }
            }
        }

        &.is-invalid {
            background-color: ${({ theme }) =>
                `${theme.colors.semantic.inValidDomain}`};
            input {
                cursor: text;
            }
            .close-btn {
                cursor: pointer;
                margin-left: 18px;
                svg {
                    fill: ${({ theme }) => `${theme.colors.semantic.error}`};
                }
            }
        }
    }

    .msg-container {
        position: relative;
    }

    .error {
        position: absolute;
        padding-top: 10px;
        font-weight: 400;
        font-size: var(--font-size-xs);
        line-height: 14px;
        color: var(--color-error);

        b {
            word-break: break-all;
        }
    }

    .example {
        margin-top: 40px;
        font-size: var(--font-size-xs);
        line-height: 16px;
        color: var(--color-dark-500);

        ul {
            padding-left: 20px;
        }
    }
`

export const Body = styled('div')`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
`

export const drawerScrollFixStyles = {
    '.cc-drawer-body:has(.add-domain-drawer)': { minHeight: 0 },
    '.cc-drawer-content:has(.add-domain-drawer)': { minHeight: 0 },
}

export const Footer = styled('div')<{ theme?: TTheme }>`
    display: flex;
    flex-shrink: 0;
    position: sticky;
    bottom: 0;
    z-index: 1;
    justify-content: flex-end;
    align-items: center;
    padding: 36px 0 0;
    background-color: ${({ theme }) => theme.colors.semantic.drawerBackground};
    border-top: 1px solid
        ${({ theme }) => theme.colors.semantic.drawerSeparator};
    .action-button {
        width: 100px;
        margin-bottom: 24px;
    }
`
